module.exports = __webpack_public_path__ + "static/media/exclaimationWarningCircleIcon.c1375022.svg";